const render = () => {
    return `
        <?php if ($_COOKIE["__umux"]=="1" || $_GET["debugger"] == "1") { ?>
            <script src="https://statics-cdn-cn.umucdn.cn/common/vconsole.min.js?v=3.2.0_<?=$pageData && $pageData.data && $pageData.data.version || 0 ?>"></script>
            <script>new VConsole();</script>
        <?php } ?>
    `;
};

export default render;
